import type React from 'react';

import type { CropperInstance, MediaCropArea } from '#src/app/shared/hooks/imageUpload';
import type { UploaderControls } from '#src/app/shared/hooks/uppyUploader';

import { ImageCropper } from '../imageCropper';
import { ImageUploader } from '../imageUploader';

type Props = {
	crop?: MediaCropArea | undefined;
	disabled?: boolean;
	/** See `ImageCropper`'s prop of the same name. */
	hideRemoveButton?: boolean;
	image?: string | null;
	uploadInputDataQa?: string;
	removeButtonDataQa?: string;
	onImageChange: (image: string | undefined) => void;
	onImageCrop: (imageCrop: MediaCropArea | undefined) => void;
	onButtonClick?: () => void;
	onCancelClick?: () => void;
	uploader: UploaderControls;
	onInitialized?: (instance: CropperInstance) => void;
	/** Tailwind classes for the dashed dropzone container (height, width, centering). Defaults to `h-[272px]` full width. */
	uploaderContainerClassName?: string;
	/** See `ImageCropper`'s prop of the same name. */
	rounded?: boolean;
	/** See `ImageCropper`'s prop of the same name. */
	instructionsClassName?: string;
};

export const ImageCropperUploader: React.FC<Props> = ({
	crop,
	disabled = false,
	hideRemoveButton = false,
	image,
	uploadInputDataQa,
	removeButtonDataQa,
	onButtonClick,
	onImageCrop,
	onImageChange,
	onCancelClick,
	uploader,
	onInitialized,
	uploaderContainerClassName,
	rounded = false,
	instructionsClassName,
}) => {
	return (
		<>
			{image && (
				<ImageCropper
					crop={crop}
					disabled={disabled}
					hideRemoveButton={hideRemoveButton}
					image={image}
					removeButtonDataQa={removeButtonDataQa}
					onCancelClick={onCancelClick}
					onImageChange={onImageChange}
					onImageCrop={onImageCrop}
					uploader={uploader}
					onInitialized={onInitialized}
					rounded={rounded}
					instructionsClassName={instructionsClassName}
				/>
			)}
			{!image && (
				<ImageUploader
					disabled={disabled}
					onButtonClick={onButtonClick}
					uppy={uploader.uppy}
					inputDataQa={uploadInputDataQa}
					containerClassName={uploaderContainerClassName}
				/>
			)}
		</>
	);
};
